<template>
    <div>
        <b-alert show>
            <span>
                Item de Contrato:
                <strong
                    >{{ itemContrato.ordem }} -
                    {{ itemContrato.descricao }}</strong
                >
                <br />Valor:
                <strong>{{ itemContrato.valorUnitario | currency }}</strong>
                <br />Saldo:
                <strong>{{ itemContrato.saldoValor | currency }}</strong>
                <br />Seq RM:
                <strong>{{ itemContrato.seqRM }}</strong>
                <br />Status:
                <app-status
                    :status="itemContrato.status == 1 ? 'ATIVO' : 'INATIVO'"
                ></app-status>
            </span>
        </b-alert>
        <div class="d-flex flex-row-reverse mb-3">
            <b-button variant="danger" @click.stop="voltar()">
                <span>
                    <i class="fa fa-history mr-2"></i> Retornar para os Itens
                </span>
            </b-button>
            <btn-atualizar-valores-em-lote-sub-item-contrato
                :itensSelecionados="subItensSelecionados"
                :apostilamento="apostilamento()"
                :contrato="contrato"
                v-if="mostrarBtnAtualizarValoresEmLoteItemContrato"
                @obterSubItensAtualizados="obterSubItensAtualizados()"
                @limparItensSelecionados="subItensSelecionados = []"
            ></btn-atualizar-valores-em-lote-sub-item-contrato>
            <btn-inserir-sub-item-contrato
                :itemContrato="itemContrato"
                :apostilamento="apostilamento()"
                :contrato="contrato"
                v-if="mostrarBtnInserirItemContrato"
                @obterSubItensAtualizados="obterSubItensAtualizados()"
            ></btn-inserir-sub-item-contrato>
        </div>
        <app-tabela
            idTabela="tblSubItensContrato"
            :itens="subItens"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="botoes"></template>
            <template slot="acoes" slot-scope="data">
                <btn-atualizar-sub-item-contrato
                    :subItem="data"
                    :contrato="contrato"
                    :apostilamento="apostilamento()"
                    @obterSubItensAtualizados="obterSubItensAtualizados()"
                    v-if="mostrarBtnAtualizarItemContrato(data)"
                ></btn-atualizar-sub-item-contrato>
                <btn-ativar-desativar-sub-item-contrato
                    :subItem="data"
                    :contrato="contrato"
                    :apostilamento="apostilamento()"
                    @obterSubItensAtualizados="obterSubItensAtualizados()"
                    v-if="mostrarBtnAtivarDesativarItemContrato"
                ></btn-ativar-desativar-sub-item-contrato>
            </template>
            <template slot="valorUnitario" slot-scope="data">
                <p class="text-right m-0">
                    {{ data.valorUnitario | currency }}
                </p>
            </template>
            <template slot="status" slot-scope="data">
                <app-status
                    :status="data.status == 1 ? 'ATIVO' : 'INATIVO'"
                ></app-status>
            </template>
            <template slot="saldoQtd" slot-scope="data">
                <span v-if="data.quantidade > 0">{{ data.saldoQtd }}</span>
                <span v-if="data.quantidade == 0">N/A</span>
            </template>
            <template slot="HEAD_itemSelecao">
                <i
                    class="fa fa-check-square fa-lg text-muted icon-button p-0 m-0"
                    title="Marcar/Desmarcar todos"
                    @click.stop="marcarDesmarcarTodas()"
                ></i>
            </template>
            <template slot="itemSelecao" slot-scope="data">
                <b-form-checkbox
                    :value="data.itemContratoId"
                    v-model="subItensSelecionados"
                    v-if="data.status === 1"
                ></b-form-checkbox>
            </template>
        </app-tabela>
    </div>
</template>

<script>
import ContratosServicos from './../ContratosServicos'
import BtnAtualizarSubItemContrato from './BtnAtualizarSubItemContrato'
import BtnInserirSubItemContrato from './BtnInserirSubItemContrato'
import BtnAtivarDesativarSubItemContrato from './BtnAtivarDesativarSubItemContrato'
import BtnAtualizarValoresEmLoteSubItemContrato from './BtnAtualizarValoresEmLoteSubItemContrato'
import { situacaoContrato } from '../SituacaoContrato'

export default {
    name: 'SubItensContrato',

    components: {
        BtnAtualizarSubItemContrato,
        BtnInserirSubItemContrato,
        BtnAtivarDesativarSubItemContrato,
        BtnAtualizarValoresEmLoteSubItemContrato
    },

    props: {
        itemContrato: {
            type: Object,
            default: () => {}
        },

        contrato: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            subItens: [],
            subItensSelecionados: [],
            campos: [
                {
                    key: 'itemSelecao',
                    label: '',
                    customHead: true
                },
                {
                    key: 'ordem',
                    label: 'Nº',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'descricaoResumida',
                    label: 'Descrição Resumida',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'valorUnitario',
                    label: 'Valor',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'quantidade',
                    label: 'Qtd',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'seqRM',
                    label: 'Seq RM',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'saldoQtd',
                    label: 'Saldo Qtd',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5
        }
    },
    methods: {
        obterSubItensAtualizados() {
            this.obterSubItens()
            this.$emit('obterApostilamentoAtualizado')
        },

        obterSubItens() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterSubItens(
                this.$route.params.contratoId,
                this.itemContrato.itemContratoId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.subItens = response.data
                    } else {
                        this.$toast.error(response.errors, 'ERROR', this.error)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        voltar() {
            this.$emit('fecharSubItens')
        },

        marcarDesmarcarTodas() {
            if (this.subItensSelecionados.length > 0) {
                this.subItensSelecionados = []
            } else {
                this.subItensSelecionados = this.subItens
                    .filter(item => {
                        return item.status === 1
                    })
                    .map(item => {
                        return item.itemContratoId
                    })
            }
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        apostilamento() {
            return (
                this.$temAcessoView('CONT-APOST-04') &&
                this.situacoesVigenteDistribuido()
            )
        },

        atualizacaoContrato() {
            return (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido()
            )
        },

        contratoElaboracao() {
            return (
                this.$temAcessoView('CONT-ELAB-01') &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        mostrarBtnAtualizarItemContrato(data) {
            if (
                (this.apostilamento() || this.atualizacaoContrato()) &&
                data.status === 1 &&
                this.itemContrato.status === 1 &&
                this.controleHistoricoAditivos()
            ) {
                return true
            } else if (
                (this.contratoElaboracao() || this.aditivoContratoIniciado()) &&
                data.status === 1 &&
                this.itemContrato.status === 1
            ) {
                return true
            }
        },

        controleHistoricoAditivos() {
            return (
                this.contrato.contratoVigente ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        },

        verificaTipoAditivoPrazo() {
            return this.contrato.aditivoContrato != null
                ? this.contrato.aditivoContrato.aditivoTiposAditivo.every(
                      x => x.idTipoAditivo == 2
                  )
                : false
        },

        aditivoContratoIniciado() {
            return (
                this.$temAcessoView('CONT-ADITIV-00') &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO &&
                !this.verificaTipoAditivoPrazo()
            )
        }
    },

    created() {
        if (!this.apostilamento() || this.itemContrato.status !== 1) {
            this.campos.shift()
        }
        this.obterSubItens()
    },

    computed: {
        mostrarBtnInserirItemContrato() {
            return (
                ((this.apostilamento() && this.itemContrato.status == 1) ||
                    this.contratoElaboracao() ||
                    this.aditivoContratoIniciado() ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            )
        },

        mostrarBtnAtivarDesativarItemContrato() {
            return (
                ((this.apostilamento() && this.itemContrato.status == 1) ||
                    this.contratoElaboracao() ||
                    this.aditivoContratoIniciado() ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            )
        },

        mostrarBtnAtualizarValoresEmLoteItemContrato() {
            return (
                ((this.apostilamento() && this.itemContrato.status == 1) ||
                    this.contratoElaboracao() ||
                    this.aditivoContratoIniciado() ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            )
        }
    },

    watch: {}
}
</script>
